import { ApiResponse } from '../shared.types';

import {
  RewardTier,
  CreateRewardTierData,
  RewardTierStatusOption,
} from './rewardTier.types';

import axiosServer from '@/services/axios';
import { transformToApiError } from '@/utils/error.ts';

const endpoint = '/rewardTier';

export const getRewardTierById = async (
  id: string
): Promise<ApiResponse<{ rewardTier: RewardTier }>> => {
  try {
    const response = await axiosServer.get(`${endpoint}/${id}`);
    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};

export const createRewardTier = async (
  data: CreateRewardTierData
): Promise<ApiResponse<{ rewardTier: RewardTier }>> => {
  try {
    const response = await axiosServer.post(endpoint, data);
    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};

export const getAllRewardTiers = async (): Promise<
  ApiResponse<{ rewardTiers: RewardTier[] }>
> => {
  try {
    const response = await axiosServer.get(endpoint);
    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};

export const getAllRewardTierStatusOptions = async (): Promise<
  ApiResponse<{ statusOptions: RewardTierStatusOption[] }>
> => {
  try {
    const response = await axiosServer.get(`${endpoint}/status`);
    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};

export const updateRewardTier = async (
  id: string,
  data: CreateRewardTierData
): Promise<ApiResponse<{ rewardTier: RewardTier }>> => {
  try {
    const response = await axiosServer.put(`${endpoint}/${id}`, data);
    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};

export const deleteRewardTier = async (
  id: string
): Promise<ApiResponse<{ rewardTier: RewardTier }>> => {
  try {
    const response = await axiosServer.delete(`${endpoint}/${id}`);
    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};
